<template>
  <b-col class="p-0 history-wrapper">
    <b-card header="Historial de Cambios" class="my-3" header-bg-variant="primary">
      <b-table
        class="history-table"
        striped
        :items="history"
        hover
        outlined
        head-variant='light'
        :fields="fields"
        :small="true"
        :sort-by.sync="sortBy"
        :sort-desc.sync="sortDesc"
        show-empty
        empty-text="No hay historial para mostrar"
        >
          <template slot="user" slot-scope="row">
            {{row.item.user ? row.item.user.firstName : ''}} {{row.item.user ? row.item.user.lastName: ''}}
          </template>
          <template slot="date" slot-scope="row">
            {{new Date(row.item.date).toLocaleDateString(locale)}}
            {{new Date(row.item.date).toLocaleTimeString(locale)}}
          </template>
          <template slot="type" slot-scope="row">
            {{types[row.item.type]}}
          </template>
          <template slot="oldValue" slot-scope="row">
            <div v-if="row.item.type === 'PRICE'">
              {{currency}} {{row.item.oldValue.price.price}}
            </div>
            <div v-if="row.item.type === 'INVENTORY'" class="inventoryContainer" v-b-tooltip.hover :title="$t('La cantidad entre parentesis es stock reservado')">
              <span class="inventoryTotal">{{row.item.oldValue.inventory.totalQuantity}}</span>
              <span class="inventoryReserved">({{row.item.oldValue.inventory.reservedQuantity ? row.item.oldValue.inventory.reservedQuantity : 0}})</span>
            </div>
          </template>
          <template slot="newValue" slot-scope="row">
            <div v-if="row.item.type === 'PRICE'">
              {{currency}} {{row.item.newValue.price.price}}
            </div>
            <div v-if="row.item.type === 'INVENTORY'" class="inventoryContainer" v-b-tooltip.hover :title="$t('La cantidad entre parentesis es stock reservado')">
              <span class="inventoryTotal">{{row.item.newValue.inventory.totalQuantity}}</span>
              <span class="inventoryReserved">({{row.item.newValue.inventory.reservedQuantity ? row.item.newValue.inventory.reservedQuantity : 0}})</span>
            </div>
          </template>

      </b-table>
    </b-card>
  </b-col>
</template>
<script>
import appConfig from '@/config/applicationConfig.js'

export default {
  name: 'SkuHistory',
  props: ['history'],
  data () {
    return {
      fields: [
        { key: 'user', label: 'Usuario', 'class': 'text-left' },
        { key: 'date', label: 'Fecha', 'class': 'text-left' },
        { key: 'type', label: 'Cambio', 'class': 'text-left' },
        { key: 'oldValue', label: 'Valor ant.', 'class': 'text-left' },
        { key: 'newValue', label: 'Nuevo valor', 'class': 'text-left' }
      ],
      sortBy: 'date',
      sortDesc: false,
      locale: appConfig.LOCALE,
      timeOptions: { timeZone: 'UTC', timeZoneName: 'short' },
      types: {
        'INVENTORY': 'Inventario',
        'PRICE': 'Precio'
      }
    }
  },
  computed: {
    currency () {
      return appConfig.CURRENCY
    }
  }
}
</script>

<style lang="scss" scoped>
  .priceOff {
    font-weight: 700;
    color: #4DBD74;
  }
  .history-wrapper {
    .card-body {
      max-height: 300px;
      overflow-y: auto;
    }
    div.card{
      border-bottom-color: transparent;
    }
  }
  .inventoryContainer {
    display: inline-block;

    .inventoryReserved {
      color: #777;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/catalog/SkuHistory.vue